import React from 'react';
import { Plus, CheckCircle, X } from 'lucide-react';

const CandidatBulkActions = ({
  selectedCandidats,
  bulkActionLoading,
  onBulkConfirm,
  onBulkReject,
  onOpenModal
}) => {
  return (
    <div className="flex justify-between items-center">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Candidats</h2>
        <p className="text-gray-600">Gestion des candidats aux concours</p>
      </div>
      <div className="flex space-x-3">
        {selectedCandidats.length > 0 && (
          <>
            <button
              onClick={onBulkConfirm}
              disabled={bulkActionLoading}
              className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors flex items-center"
            >
              {bulkActionLoading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Confirmation...
                </>
              ) : (
                <>
                  <CheckCircle className="h-4 w-4 mr-2" />
                  Confirmer ({selectedCandidats.length})
                </>
              )}
            </button>
            <button
              onClick={onBulkReject}
              disabled={bulkActionLoading}
              className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors flex items-center"
            >
              {bulkActionLoading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Rejet...
                </>
              ) : (
                <>
                  <X className="h-4 w-4 mr-2" />
                  Rejeter ({selectedCandidats.length})
                </>
              )}
            </button>
          </>
        )}
        <button
          onClick={() => onOpenModal()}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[#202654] hover:bg-[#202654]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#202654]"
        >
          <Plus className="h-4 w-4 mr-2" />
          Nouveau Candidat
        </button>
      </div>
    </div>
  );
};

export default CandidatBulkActions; 